const FETCH_REPORT_PAYROLLS = 'fetch_reportPayrolls';
const FETCH_REPORT_PAYROLL = 'fetch_reportPayroll';
const DELETE_REPORT_PAYROLL = 'delete_reportPayroll';
const PERSIST_REPORT_PAYROLL = 'persist_reportPayroll';
const PAID_REPORT_PAYROLLS = 'paid_reportPayroll';
const FETCH_PAYROLLS_REPORTS_CSV = 'fetch_reportPayrolls_csv';
export default {
    FETCH_REPORT_PAYROLLS,
    FETCH_REPORT_PAYROLL,
    DELETE_REPORT_PAYROLL,
    PAID_REPORT_PAYROLLS,
    PERSIST_REPORT_PAYROLL,
    FETCH_PAYROLLS_REPORTS_CSV,
};
